import React from "react";
import Calendar from 'react-calendar';
import { toast } from "react-toastify";
import { Form, FormGroup, Input, Label, FormText } from "reactstrap";
import FormTopMenu from "../../Components/FormTopMenu";
import ImageUploadControl from "../../Components/ImageUploadControl";
import { DEFAULT_COUNTRY, tipStatus } from "../../config";
import CommonApi from "../../Core/Api/CommonApi";
import TipsApi from "../../Core/Api/TipsApi";
import { dateToStr, strToDate } from '../../Core/Utils';
import Layout from "../../Layout/Layout";

class TipEdit1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      title_image_original: null,
      title_image_settings: null,
      body: '',
      meta_description: '',
      status: tipStatus.Draft,
      created_at: '',
      published_at: new Date(),
      country_code: DEFAULT_COUNTRY,
      city: '',
      allCountries: [],
      displayPublishConfirmation: false,
      error: ''
    };

    this.id = props.match.params.id ? props.match.params.id : '';

    this.q = null;
  }

  componentDidMount = () => {

    this.fetchCountries();

    // If the tip is new, don't try to load it from the remote source.
    if (!this.id) {
      return;
    }

    this.fetchTip(this.id);
  };

  render = () => {

    const {
      title,
      title_image_original,
      title_image_settings,
      meta_description,
      published_at,
      country_code,
      allCountries,
      city
    } = this.state;

    const id = this.id;

    return (
      <Layout bg="light">
        <FormTopMenu items={[
            { action: this.handleSaveClick.bind(null, false), label: !id ? "SAVE DRAFT" : "UPDATE" },
            { action: this.handleSaveClick.bind(null, true), label: "CONTINUE >" }
        ]} />

        <main className="normal-container mb-5 mt-2">
          <Form className="p-3">
            <Input id="id" name="id" type="hidden" defaultValue={id} />
            <FormGroup>
              <Label for="title">Title</Label>
              <Input
                type="text"
                name="title"
                id="title"
                placeholder="Title"
                defaultValue={title}
                onChange={this.handleInputChange}
                onKeyDown={this.handleInputKeyDown}
                required={true}
              />
            </FormGroup>
            <FormGroup>
              <Label for="published_at">Date</Label>
              <Calendar
                name="published_at"
                onChange={this.handleDateChange}
                value={published_at}
                locale="es"
                className="calendar"
              />
            </FormGroup>
            <FormGroup>
              <Label for="country_code">Country</Label>
              <Input
                type="select"
                name="country_code"
                id="country_code"
                value={country_code}
                onChange={this.handleInputChange}
                placeholder="Select..."
                required={true}
              >
                {allCountries.map(item => (
                  <option value={item.code} key={item.code}>
                    {item.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="city">City</Label>
              <Input
                type="text"
                name="city"
                id="city"
                defaultValue={city}
                onChange={this.handleInputChange}
                onKeyDown={this.handleInputKeyDown}
              />
            </FormGroup>

            <FormGroup>
              <Label for="title_image">Title image</Label>
              <ImageUploadControl 
                onSave={this.handleImageUpload}
                originalImagePath={title_image_original}
                originalImageSettings={title_image_settings}
              />
            </FormGroup>

            <hr className="d-block mt-5 pb-4" />

            <FormGroup>
              <Label for="meta_description">Meta Description</Label>
              <Input
                type="textarea"
                name="meta_description"
                id="meta_description"
                placeholder=""
                value={meta_description}
                onChange={this.handleInputChange}
                onKeyDown={this.handleInputKeyDown}
              />
              <FormText>Recommended length: 50-160 characters</FormText>
            </FormGroup>
          </Form>
        </main>
      </Layout>
    );
  };

  handleImageUpload = (originalImageBlob, originalImageSettings, croppingRect) => {
    TipsApi
      .uploadTipTitleImage(this.id, originalImageBlob, originalImageSettings, croppingRect)
      .then(data => {
        if (data.data.uploadTipTitleImage && data.data.uploadTipTitleImage.id) {
          const tip = data.data.uploadTipTitleImage;
          this.setState({
            title_image_original: tip.title_image_original,
            title_image_settings: tip.title_image_settings
          });

          toast('The image have been saved successfully');
        } else {
          console.warn(data);
          this.reportError("An error occured.");
        }
      })
      .catch(err => {
        console.warn(err);
        this.reportError("An error occured.");
      });
  }

  handleDateChange = date => {
    this.setState({
      published_at: date
    });
  }

  handleInputChange = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  handleInputKeyDown = event =>  {
    // We have to handle Backspace for inputs additionally.
    if (event.keyCode === 8) {
     this.handleInputChange(event);
    }
  }

  handleSaveClick = (redirectToNext = false) => {
    const tip = Object.assign({}, this.state);
    tip.published_at = dateToStr(tip.published_at);

    if (!tip.id) {
        this.createTip(tip, redirectToNext);
    } else {
        this.updateTip(tip, redirectToNext);
    }
  };

  createTip = (tip, redirectToNext) => {
    TipsApi.createTip(tip)
      .then(data => {
        if (data.data.createTip) {
          const state = data.data.createTip;

          if (state.published_at) {
            state.published_at = strToDate(state.published_at);
          }

          this.setState(state);

          this.props.history.push(redirectToNext ? `/tip/${state.id}/body/` : '/tips');
        } else {
          // @todo: Handle errors better.
          console.warn(data);
          this.reportError("An error occured.");
        }
      })
      .catch(err => {
        // @todo: Handle errors better.
        console.warn(err);
        this.reportError("An error occured.");
      });
  }

  updateTip = (tip, redirectToNext) => {
    TipsApi.updateTip(tip)
      .then(data => {
        if (data.data.updateTip) {
          const state = data.data.updateTip;

          if (state.published_at) {
            state.published_at = strToDate(state.published_at);
          }
          
          this.setState(state);

          this.props.history.push(redirectToNext ? `/tip/${state.id}/body/` : '/tips');
        } else {
          // @todo: Handle errors better.
          console.warn(data);
          this.reportError("An error occured.");
        }
      })
      .catch(err => {
        // @todo: Handle errors better.
        console.warn(err);
        this.reportError("An error occured.");
      });
  }

  fetchCountries = () => {
    CommonApi.fetchCountries()
    .then(data => {
      if (data.data.countries && data.data.countries.length > 0) {
        this.setState({
          'allCountries': data.data.countries
        });
      } else {
        // @todo: Handle errors better.
        console.warn(data);
        this.reportError("An error occured.");
      }
    })
    .catch(err => {
      // @todo: Handle errors better.
      console.warn(err);
      this.reportError("An error occured.");
    });
  }

  fetchTip = (id) => {
    TipsApi.fetchTip(id)
    .then(data => {
      if (data.data.tips && data.data.tips.length > 0) {
        const tip = data.data.tips[0];

        if (tip.country_code === null) {
          tip.country_code = '';
        }

        if (tip.published_at) {
          tip.published_at = strToDate(tip.published_at);
        }

        this.setState(tip);
      } else {
        // @todo: Handle errors better.
        console.warn(data);
        this.reportError("An error occured.");
      }
    })
    .catch(err => {
      // @todo: Handle errors better.
      console.warn(err);
      this.reportError("An error occured.");
    });
  }

  reportError = message => {
    toast.error(message)
  };
}

export default TipEdit1;
